/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OfferArticlesResponse } from '../../models/offer-articles-response';

export interface GetOfferArticles$Params {
  page: number;
  pageSize: number;
  orderBy?: string;
  filter?: string;
  id: number;
}

export function getOfferArticles(http: HttpClient, rootUrl: string, params: GetOfferArticles$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferArticlesResponse>> {
  const rb = new RequestBuilder(rootUrl, getOfferArticles.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('filter', params.filter, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OfferArticlesResponse>;
    })
  );
}

getOfferArticles.PATH = '/offers/{id}/articles';
